export const setFrameHeight = () => {
  const height = document.getElementById('ddn-search-content').scrollHeight
  window.parent.postMessage(height, '*')
}
